// `useCanManageProperty` — gate for the content-mutating property actions
// (edit info, change price, manage images, delete). Mirrors the backend
// `@propertyAccess.canManage` rule:
//   OWNER / MANAGER  → always
//   SOURCE           → only when they are the assigned (responsible) broker
//   VIEWER / AGENT   → never
//
// This ALSO gates the quick-status pill on the detail page: PATCH /status now
// runs through the same backend `@propertyAccess.canManage` rule, so a
// non-manager sees the status but can't change it. The backend @PreAuthorize is
// the real boundary; this just hides actions the current user can't perform.

import { useAuthStore } from "@/lib/auth-store";
import type { Property } from "@/types/property";

export function useCanManageProperty(property: Property): boolean {
  const user = useAuthStore((s) => s.user);
  if (user === null) return false;
  const role = user.role.toUpperCase();
  if (role === "OWNER" || role === "MANAGER") return true;
  if (role === "SOURCE") {
    return (
      property.assignedBrokerId !== null &&
      property.assignedBrokerId === user.id
    );
  }
  return false; // VIEWER, AGENT and anything else
}
